import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface NewRegulatoryTrainingMatrixFilterAtom {
	generalInformationJobTitle: string[];
	workStation: number[];
	training: number[];
	company: number[];
	onlyUnmappedPositions: boolean;
	onlyUnmappedTrainings: boolean;
}

const numberArrayChecker = r.withDefault(r.array(r.number()), []) as r.Checker<
	number[]
>;

const stringArrayChecker = r.withDefault(r.array(r.string()), []) as r.Checker<
	string[]
>;

export const newRegulatoryTrainingMatrixFilterAtom =
	atom<NewRegulatoryTrainingMatrixFilterAtom>({
		key: 'newRegulatoryTrainingMatrixFilterAtom',
		default: {
			generalInformationJobTitle: [],
			workStation: [],
			training: [],
			company: [],
			onlyUnmappedPositions: false,
			onlyUnmappedTrainings: false,
		},
		effects: [
			urlSyncEffect<NewRegulatoryTrainingMatrixFilterAtom>({
				refine: r.object({
					generalInformationJobTitle: stringArrayChecker,
					workStation: numberArrayChecker,
					training: numberArrayChecker,
					company: numberArrayChecker,
					onlyUnmappedPositions: r.withDefault(r.bool(), false),
					onlyUnmappedTrainings: r.withDefault(r.bool(), false),
				}),
				history: 'push',
			}),
		],
	});
